import { render, staticRenderFns } from "./NavCard.vue?vue&type=template&id=49d6542c&scoped=true&"
import script from "./NavCard.vue?vue&type=script&lang=js&"
export * from "./NavCard.vue?vue&type=script&lang=js&"
import style0 from "./NavCard.vue?vue&type=style&index=0&id=49d6542c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6542c",
  null
  
)

export default component.exports